import { Injectable } from '@angular/core';
import { HttpService } from '../http/http.service';
import { environment } from 'environments/environment';
import { apiConstant } from '../constant/apiConstant';

@Injectable({
  providedIn: 'root'
})
export class LoginService {
  constructor(private httpService: HttpService) {}

  login(payload: any) {
    return this.httpService.post(`${environment.baseUrl}${apiConstant.login}?authValid=auth`, payload);
  }

  logout() {
    return this.httpService.post(`${environment.baseUrl}${apiConstant.logout}`, {});
  }

  getSSODetails(id: any) {
    return this.httpService.get(`${environment.baseUrl}${apiConstant.ssoDetails}/${id}?authValid=auth`);
  }

  verifyOtp(payload: any) {
    return this.httpService.post(`${environment.baseUrl}${apiConstant.verifyOTP}`, payload);
  }

  resendOtp(payload: any) {
    return this.httpService.post(`${environment.baseUrl}${apiConstant.resendOTP}`, payload);
  }

  forgotUserName(payload: any) {
    return this.httpService.post(`${environment.baseUrl}${apiConstant.forgotUsername}?authValid=auth`, payload);
  }

  forgotpassword(payload: any) {
    return this.httpService.post(`${environment.baseUrl}${apiConstant.ForgotPassword}?authValid=auth`, payload);
  }

  selectBoardAndRolesAndPermission(payload: any, isAuth?: any) {
    return this.httpService.post(`${environment.baseUrl}${apiConstant.authLoginBoard}`, payload);
  }

  changePasswordLoginUser(payload: any) {
    return this.httpService.post(`${environment.baseUrl}${apiConstant.authLoginChangePaasword}`, payload);
  }

  getBoards() {
    return this.httpService.get(`${environment.baseUrl}${apiConstant.authUserBoard}`);
  }

  forgotPwd_Initiate(username: string, captchaResponse: string) {
    const payload: any = {
      Username: username,
      CaptchaResponse: captchaResponse
    };

    return this.httpService.post(`${environment.baseUrl}Security/ForgotPassword/Initiate?authValid=auth`, payload);
  }

  forgotPwd_Answer(username: string, question: string, answer: string, nonce: string) {
    const payload: any = {
      Username: username,
      Question: question,
      Answer: answer,
      NonceId: nonce
    };

    return this.httpService.post(`${environment.baseUrl}Security/ForgotPassword/Answer?authValid=auth`, payload);
  }

  forgotPwd_SetPwd(username: string, question: string, answer: string, newPwd: string, confirmPwd: string, nonce: string) {
    const payload: any = {
      Username: username,
      Question: question,
      Answer: answer,
      NewPassword: newPwd,
      ConfirmPassword: confirmPwd,
      NonceId: nonce
    };

    return this.httpService.post(`${environment.baseUrl}Security/ForgotPassword/SetPassword?authValid=auth`, payload);
  }
}

